// components/icons/Search.tsx

import React from 'react';

const Search: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      d="M14.584 14.5833L18.334 18.3333"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.667 9.16675C16.667 5.02461 13.3091 1.66675 9.16699 1.66675C5.02486 1.66675 1.66699 5.02461 1.66699 9.16675C1.66699 13.3089 5.02486 16.6667 9.16699 16.6667C13.3091 16.6667 16.667 13.3089 16.667 9.16675Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
);

export default Search;
